import React, { Component } from "react";
import { Table, Button } from "antd";
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";

import { alert } from "../../../common/utils/alert";

import { SearchBar } from "../../../components/common/search-bar";
import { Tabs } from "../../../components/common/tabs";
import { ContractStatus } from "./contract-list/contract-status";
import { ContractNew } from "./contract-detail/contract-new";
import { DriverlessContract } from "./contract-detail/driverless-contract";
import { apiConstract } from "../../../api/api-constract";
import { apiContract } from "../../../api/api-contract";
import { emitter } from "../../../common/utils/emitter";
import { CONTRACT_TYPE } from "../../../common/utils/static-data";
import moment from "moment";
import { api } from "../../../api/api";

const STATUS_DATA = {
  1: "#fbe350",
  2: "#e68927",
  3: "#45acf9",
  4: "#139123",
  5: "#d11338",
  6: "#b330dc",
  7: "#32dc8e",
  8: "#E60EBB",
};

export class ContractTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isContractNew: false,
      tab: CONTRACT_TYPE.has_driver,
      constracts_status: {},
      exportFilter: {
        driver: null,
        vehicle: null,
        branch: null,
        code: null,
        created_at: null,
        created_by: null,
        customer: {
          name: null,
        },
        driver_is_transferred_another: null,
        vehicle_is_transferred_another: null,
        term: null,
        sign_date: null,
        status: null,
        contract_type: {
          id: 1,
        },
      },
    };

    this.LEND = [
      { id: 0, name: "Tất cả", type: "all" },
      { id: 1, name: "Đang cho mượn xe & tài", type: "driver_car" },
      { id: 2, name: "Đang cho mượn xe", type: "car" },
      { id: 3, name: "Đang cho mượn tài", type: "driver" },
    ];

    this.contractTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Mã hợp đồng",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "Ngày ký",
        dataIndex: "sign_date",
        key: "sign_date",
        render: (item) => {
          const time_unix = moment(item).format("DD/MM/YYYY");
          return item ? <span>{time_unix}</span> : null;
        },
      },
      {
        title: "Thời hạn HĐ (tháng)",
        dataIndex: "term",
        key: "term",
        render: (term) => {
          return term ? <span style={{ minWidth: 50 }}>{term}</span> : null;
        },
      },
      {
        title: "Chi nhánh quản lý xe",
        dataIndex: "branch",
        key: "branch",
        render: (branch) => <span>{branch.code}</span>,
      },
      {
        title: "Khách hàng",
        dataIndex: "customer",
        key: "customer",
        render: (customer) => <span>{customer.name}</span>,
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        render: (status) => {
          return (
            <span
              style={{ background: STATUS_DATA[status] }}
              className="circle"
            />
          );
        },
      },
      {
        title: "Biển KS",
        dataIndex: "vehicle",
        key: "vehicle",
        render: (vehicle) => <span>{vehicle ? vehicle.number_plate : ""}</span>,
      },
      {
        title: "Tài xế",
        dataIndex: "driver",
        key: "driver",
        render: (driver) => <span>{driver ? driver.name : ""}</span>,
      },
      {
        title: "Người tạo",
        dataIndex: "created_by",
        key: "created_by",
        render: (item) => <div style={{ minWidth: 120 }}>{item.name}</div>,
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "id",
        render: (data) => (
          <div onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
    this.page = 1;
  }

  async componentDidMount() {
    this.handleStatistic(1);
  }

  showDetail = (data) => {
    this.handleNewContract(
      true,
      {
        ...data,
        contract_code: {
          prefix_code: data.prefix_code,
          suffix_code: data.suffix_code,
        },
        limitEdit: false,
        unlimitEdit: false,
        isEdit: false,
      },
      "edit"
    );
  };

  getData = async (page, contract_type_id) => {
    const { state } = this.search;
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    if (state.checkSearch) {
      this.setState({
        exportFilter: {
          driver: state.driver
            ? {
                name: `%${state.driver.trim().replace(/%/gi, "\\%")}%`,
              }
            : null,
          vehicle: state.number_plate
            ? {
                number_plate: `%${state.number_plate
                  .trim()
                  .replace(/%/gi, "\\%")}%`,
              }
            : null,
          branch: state.branch
            ? {
                code: state.branch,
              }
            : null,
          code: state.contract_code
            ? `%${state.contract_code
                .trim()
                .replace(/%/gi, "\\%")
                .replace(/_/g, "\\_")}%`
            : null,
          created_at: state.created_date ? `${state.created_date}` : null,
          created_by: state.creator
            ? {
                name: state.creator
                  ? `%${state.creator.trim().replace(/%/gi, "\\%")}%`
                  : null,
              }
            : null,
          customer: {
            name: state.customer
              ? `%${state.customer.trim().replace(/%/gi, "\\%")}%`
              : null,
          },
          driver_is_transferred_another: state.status
            ? state.status === 7 || state.status === 8
              ? true
              : false
            : null,

          vehicle_is_transferred_another: state.status
            ? state.status === 6 || state.status === 8
              ? true
              : false
            : null,
          term: state.duration
            ? `${state.duration.trim().replace(/%/gi, "\\%")}`
            : null,
          sign_date: state.signing_date ? state.signing_date : null,
          status:
            state.status &&
            state.status !== 6 &&
            state.status !== 7 &&
            state.status !== 8
              ? state.status
              : null,
          contract_type: {
            id: contract_type_id,
          },
        },
      });
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiConstract.getContracts(
        this.state.exportFilter,
        page
      );

      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            lend: [
              value.vehicle_is_transferred_another,
              value.driver_is_transferred_another,
            ],
            status: this.getStatus(value),
            data: value,
          };
        });
        this.setState({
          dataTable: dataConvert,
          total: result.data.total_elements,
        });
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  getStatus = (contract) => {
    if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === false
    ) {
      return contract.status;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === false
    ) {
      return 7;
    } else if (
      contract.driver_is_transferred_another === false &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 6;
    } else if (
      contract.driver_is_transferred_another === true &&
      contract.vehicle_is_transferred_another === true
    ) {
      return 8;
    }

    return contract.status;
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    const { tab } = this.state;
    this.getData(page, tab === CONTRACT_TYPE.has_driver ? 1 : 2);
  };

  handleNewContract = (status, data, typeOption) => {
    this.setState({ isContractNew: status }, () => {
      const element = document.getElementById("right-layout");
      element.scrollTo(0, 0);
      if (data) {
        this.contractNew.updateForm(data, typeOption);
      }
      if (!status) {
        const { tab } = this.state;
        this.handleStatistic(tab === CONTRACT_TYPE.has_driver ? 1 : 2);
      }
    });
  };

  async handleStatistic(contract_type_id) {
    try {
      emitter.emit("FETCH_LOADING", true);
      const dataResult = await apiContract.getStatistic(contract_type_id);
      if (dataResult.status === "success") {
        this.setState({ constracts_status: dataResult.data });
        this.getData(1, contract_type_id);
      } else {
        emitter.emit("FETCH_LOADING", false);
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  }

  onChangeTab = (tab) => {
    this.setState({ tab, isContractNew: false }, () => {
      const { tab } = this.state;
      this.handleStatistic(tab === CONTRACT_TYPE.has_driver ? 1 : 2);
      this.setState({
        exportFilter: {
          contract_type: {
            id: tab === CONTRACT_TYPE.has_driver ? 1 : 2,
          },
        },
      });
    });
  };

  handleExportContract = async () => {
    try {
      const { exportFilter, total } = this.state;
      const totalItem = total < 10 ? 10 : total;
      emitter.emit("FETCH_LOADING", true);
      apiContract.exportContract(exportFilter, 1, totalItem).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  render() {
    const {
      dataTable,
      total,
      isContractNew,
      constracts_status,
      tab,
    } = this.state;
    return (
      <div className="contract-table contract">
        <Tabs onChangeTab={this.onChangeTab} />
        {!isContractNew ? (
          <>
            <ContractStatus
              has_driver={tab === CONTRACT_TYPE.has_driver}
              data={constracts_status}
            />
            <SearchBar
              has_driver={tab === CONTRACT_TYPE.has_driver}
              search={(page) =>
                this.getData(page, tab === CONTRACT_TYPE.has_driver ? 1 : 2)
              }
              ref={(ref) => (this.search = ref)}
              type="CONTRACT"
            />
            <Table
              childrenColumnName="contract-column"
              rowKey={(record) => record.id}
              style={{ width: "100%" }}
              rowClassName="table-row"
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              columns={this.contractTable}
            />
            <div className="button-container">
              <Button
                onClick={() => this.handleNewContract(true, null, "create_new")}
                className="add-btn"
              >
                <PlusOutlined /> Thêm hợp đồng
              </Button>
              <Button
                className="export-btn"
                onClick={this.handleExportContract}
              >
                <PrinterOutlined /> Export
              </Button>
            </div>
          </>
        ) : tab === CONTRACT_TYPE.has_driver ? (
          <ContractNew
            ref={(ref) => (this.contractNew = ref)}
            close={() => this.handleNewContract(false)}
          />
        ) : (
          <DriverlessContract
            ref={(ref) => (this.contractNew = ref)}
            close={() => this.handleNewContract(false)}
          />
        )}
      </div>
    );
  }
}
